import { isClientSide } from '@naturalcycles/js-lib'
import { useEffect, useState } from 'react'

/**
 * @notes
 * ⚠️ The use of this hook is discouraged and native CSS solutions are to be preferred ⚠️
 *
 * Why is the use discouraged?
 * The hook returns null values on initial render due to the window object being undefined.
 * Waiting for the window object to be defined before rendering can cause layout shifts (CLS) and decrease performances.
 *
 * For these reasons, native CSS solutions are to be preferred.
 */
export function useWindowDimensions(): WindowDimensions {
  const [windowDimensions, setWindowDimensions] = useState<WindowDimensions>({
    width: null,
    height: null,
  })

  useEffect(() => {
    if (!isClientSide()) {
      setWindowDimensions({ width: null, height: null })
    } else {
      setWindowDimensions({ width: window.innerWidth, height: window.innerHeight })
    }

    function handleResize(): void {
      setWindowDimensions({ width: window.innerWidth, height: window.innerHeight })
    }

    if (!isClientSide()) return
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}

interface WindowDimensions {
  width: number | null
  height: number | null
}
